import { useEffect } from "react";

import { Alert } from "@smart/itops-sb-design-system-dom";

type ConnectionBannerProps = {
  connectionError: boolean;
  showConnectionBanner?: [
    boolean,
    React.Dispatch<React.SetStateAction<boolean>>,
  ];
  retry: (() => void) | undefined;
};
export const ConnectionBanner = ({
  connectionError,
  showConnectionBanner,
  retry,
}: ConnectionBannerProps) => {
  useEffect(() => {
    if (connectionError && showConnectionBanner) {
      showConnectionBanner[1](true);
    }
  }, [connectionError]);

  return (
    showConnectionBanner &&
    showConnectionBanner[0] && (
      <Alert
        palette={connectionError ? "destructive" : "success"}
        content={
          connectionError
            ? "Failed to save your form."
            : "Your changes will be saved automatically as you complete the form."
        }
        action={
          connectionError && retry
            ? {
                text: "Try again",
                onClick: retry,
              }
            : undefined
        }
        onClose={() => showConnectionBanner[1](false)}
      />
    )
  );
};
